<template>
  <div id="chatContextMenu" @click="preventEvent">
    <div id="chatClickedUser"></div>
    <div class="chatContextMenuItem" v-for="(item, index) in (isAdmin ? adminMenuList:menuList)" :key="index" @click="item.link === null ? 'javascript:;':item.link(this, item.functionIndex)" :class="item.class === 'noContents'? 'noContents':''">
      <span class="chatContextMenuIcon" v-if="item.class !== 'noContents'" :class="item.class"></span>
      <span class="chatContextMenuText" :class="item.class.indexOf('dangerousButton') >= 0 ? 'dangerousButton':''">{{ item.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    let isGuest = function () {
      // console.log(/^GUEST_(a-zA-Z)*/g.test(userid), sessID, userid)
      if (/^GUEST_(a-zA-Z)*/g.test(window.userid) || window.sessID === '') {
        printNotifyMessage('로그인후 사용할 수 있는 기능입니다.') // eslint-disable-line
        window.parent.postMessage({commend: 'show_login_popup_layer', popupCommend: '', href: ''}, '*')
        return true
      } else {
        return false
      }
    }
    let hideContextMenu = function () {
      // console.log('hideContextMenu')
      let contextMenu = document.getElementById('chatContextMenu')
      contextMenu.style.top = '-1000px'
      contextMenu.style.left = '-1000px'
      contextMenu.style.opacity = '0'
    }

    let viewMemberInfo = function (el) {
      hideContextMenu()
      let element = document.getElementById('chatClickedUser')
      let uid = element.getAttribute('rel')
      let popUrl = '/user2/namecard.php?mb_id=' + uid
      let popOption = 'width=749, height=820, resizable=no, scrollbars=no, status=no;'
      window.open(popUrl, 'win_namecard', popOption)
    }

    let viewMemberInfoByAdmin = function (el) {
      hideContextMenu()
      let element = document.getElementById('chatClickedUser')
      let uid = element.getAttribute('rel')
      let popUrl = '/_admin_/member_form.php?w=u&mb_id=' + uid
      window.open(popUrl, '_blank')
    }

    let sendMessage = function (el) {
      if (member_no === '') { // eslint-disable-line
        window.parent.postMessage({commend: 'show_login_popup_layer', popupCommend: '', href: ''}, '*')
        hideContextMenu()
        return false
      }

      hideContextMenu()
      if (isGuest()) {
        return
      }
      let element = document.getElementById('chatClickedUser')
      let uid = element.getAttribute('rel')
      newWindow('/memo/memo_form.php?me_recv_mb_id=' + uid, '_memo', 595, 485, 0, 0)
    }

    let sendTradePoint = function (el) {
      if (member_no === '') { // eslint-disable-line
        window.parent.postMessage({commend: 'show_login_popup_layer', popupCommend: '', href: ''}, '*')
        hideContextMenu()
        return false
      }

      hideContextMenu()
      if (isGuest()) {
        return
      }
      let element = document.getElementById('chatClickedUser')
      let uid = element.getAttribute('rel')
      newWindow('/memo/memo_form.php', '_memo', 650, 626, 1, 0)
    }

    let talkBetweenChat = function (el) {
      if (member_no === '') { // eslint-disable-line
        window.parent.postMessage({commend: 'show_login_popup_layer', popupCommend: '', href: ''}, '*')
        hideContextMenu()
        return false
      }

      hideContextMenu()
      let element = document.getElementById('chatClickedUser')
      let uid = element.getAttribute('rel')
      if (uid === window.userid) {
        alert('자기 자신과는 1:1 채팅이 불가능 합니다.')
        return
      }
      window.open('./date.php?target_site_id=' + window.site_id + '&tuserid=' + uid + '&tname=' + element.innerText + '&mode=REQ_DATE', 'private_chat' + uid, 'width=480, height=640, resizable=no, scrollbars=no, status=no;')
    }

    let openDateWindow = function (target_site_id, tuserid, tname, mode) { // eslint-disable-line
      hideContextMenu()
      var url = '/nlivechat/date.php?target_site_id=' + target_site_id + '&tuserid=' + tuserid + '&tname=' + tname + '&mode=' + mode // eslint-disable-line
      window.open(url, '_blank', 'width=420, height=490, scrollbar=no')
    }

    let addFriend = function (el) {
      if (member_no === '') { // eslint-disable-line
        window.parent.postMessage({commend: 'show_login_popup_layer', popupCommend: '', href: ''}, '*')
        hideContextMenu()
        return false
      }

      hideContextMenu()
      if (isGuest()) {
        return
      }
      let element = document.getElementById('chatClickedUser')
      let uid = element.getAttribute('rel')
      window.open('/pop/add_friend.php?mb_id=' + uid, 'friend_' + uid, 'scrollbars=no,toolbar=no,location=no,directories=no,status=yes,resizable=yes,width=415,height=432,left=0,top=0')
    }

    let addBlacklist = function (el) {
      if (member_no === '') { // eslint-disable-line
        window.parent.postMessage({commend: 'show_login_popup_layer', popupCommend: '', href: ''}, '*')
        hideContextMenu()
        return false
      }

      hideContextMenu()
      if (isGuest()) {
        return
      }
      let element = document.getElementById('chatClickedUser')
      let uid = element.getAttribute('rel')
      window.open('/pop/add_friend.php?mb_id=' + uid + '&mf_type=BAD', 'friend_' + uid, 'scrollbars=no,toolbar=no,location=no,directories=no,status=yes,resizable=yes,width=415,height=432,left=0,top=0') // eslint-disable-line
    }

    let newWindow = function(a_str_windowURL, a_str_windowName, a_int_windowWidth, a_int_windowHeight, a_bool_scrollbars, a_bool_resizable) { // eslint-disable-line
      hideContextMenu()
      var int_windowLeft = (screen.width - a_int_windowWidth) / 2 // eslint-disable-line
      var int_windowTop = (screen.height - a_int_windowHeight) / 2 // eslint-disable-line
      var str_windowProperties = 'height=' + a_int_windowHeight + ',width=' + a_int_windowWidth + ',top=' + int_windowTop + ',left=' + int_windowLeft + ',scrollbars=' + a_bool_scrollbars + ',resizable=' + a_bool_resizable + '' // eslint-disable-line
      var obj_window = window.open(a_str_windowURL, a_str_windowName, str_windowProperties) // eslint-disable-line
      if (obj_window == null) { // eslint-disable-line
        alert('차단된 팝업창을 허용해 주십시오.')
      } else if (parseInt(navigator.appVersion) >= 4) {
        obj_window.window.focus() // eslint-disable-line
      }
    }

    let givePenalty = function (el, penaltyType) {
      hideContextMenu()
      // console.log('el', el, 'penaltyType', penaltyType)
      if (penaltyType === undefined) {
        penaltyType = ''
      }
      let element = document.getElementById('chatClickedUser')
      let uid = element.getAttribute('rel')
      window.open('/pop/penalty.php?mb_id=' + uid + '&penaltyType=' + penaltyType + '&rel=chatting&site_id=' + window.site_id, 'win_Penalty', 'scrollbars=no,toolbar=no,location=no,directories=no,status=yes,resizable=yes,width=415,height=350,left=50,top=50')
    }

    let doMute = function (el) {
      hideContextMenu()
      let element = document.getElementById('chatClickedUser')
      let uid = element.getAttribute('rel')
      let nick = element.innerText
      window.adminCmd('SILENT', uid, nick) // eslint-disable-line no-undef
    }

    let doUnMute = function (el) {
      hideContextMenu()
      let element = document.getElementById('chatClickedUser')
      let uid = element.getAttribute('rel')
      let nick = element.innerText
      window.adminCmd('UNSET SILENT', uid, nick) // eslint-disable-line no-undef
    }

    let doBan = function (el) { // eslint-disable-line
      hideContextMenu()
      let element = document.getElementById('chatClickedUser')
      let uid = element.getAttribute('rel')
      let nick = element.innerText
      window.adminCmd('BAN', uid, nick) // eslint-disable-line no-undef
    }

    let doBlockPc = function (el) { // eslint-disable-line no-unused-vars
      hideContextMenu()
      let element = document.getElementById('chatClickedUser')
      let uid = element.getAttribute('rel')
      let nick = element.innerText
      if (confirm('정말 차단하시겠습니까?')) {
        window.adminCmd('BLOCK_PC', uid, nick) // eslint-disable-line no-undef
      }
    }

    //기본 관리자 메뉴
    let adminMenuList =  [
        { name: '회원정보수정', class: 'userInfo', link: viewMemberInfoByAdmin },
        { name: '쪽지보내기', class: 'sendMessage', link: sendMessage },
        { name: '채팅신청', class: 'askChat', link: talkBetweenChat },
        // { name: '건빵선물하기', class: 'sendTradePoint', link: sendTradePoint }, 임시적 주석
      ];

    // 최고 관리자 및 일반 관리자의 경우 메뉴 추가
    if(window.is_admin_auth === "SuperAdmin" || window.is_admin_auth === "Administrator"){
      adminMenuList.push(
        { name: '--------------------', class: 'noContents', link: null },
        { name: '개인정보노출', class: 'givePenalty dangerousButton', link: givePenalty, functionIndex: 3 },
        { name: '운영자,사이트비방', class: 'givePenalty dangerousButton', link: givePenalty, functionIndex: 2 },
        { name: '개인,불법적인홍보행위', class: 'givePenalty dangerousButton', link: givePenalty, functionIndex: 4 },
        { name: '--------------------', class: 'noContents', link: null },
        { name: '전과부여', class: 'givePenalty', link: givePenalty },
        // { name: '강제차단', class: 'doBan', link: doBan },
        { name: '채팅금지', class: 'doMute', link: doMute },
        { name: '채팅금지해제', class: 'doUnMute', link: doUnMute }
      )
    }
    return {
      isAdmin: window.is_admin === undefined ? false : window.is_admin,
      // isAdminAuth : window.is_admin_auth,
      menuList: [
        { name: '유저정보', class: 'userInfo', link: viewMemberInfo },
        { name: '쪽지보내기', class: 'sendMessage', link: sendMessage },
        { name: '채팅신청', class: 'askChat', link: talkBetweenChat },
        { name: '친구등록', class: 'addFriend', link: addFriend },
        { name: '블랙리스트', class: 'addBlacklist', link: addBlacklist },
        { name: '건빵선물하기', class: 'sendTradePoint', link: sendTradePoint }
      ],
      adminMenuList
    }
  },
  methods: {
    preventEvent (e) {
      // console.log(e)
      e.preventDefault()
      e.stopPropagation()
    }
  },
  beforeCreate: function () {
    // remove context menu
    document.body.addEventListener('click', function (e) {
      var contextMenu = document.getElementById('chatContextMenu')
      // console.log(e, contextMenu)
      if (contextMenu) {
        // hide context menu
        contextMenu.style.top = '-1000px'
        contextMenu.style.left = '-1000px'
        contextMenu.style.opacity = '0'
      }
    })
  }
}
</script>

<style lang="scss">
#chatContextMenu {
  position: fixed;
  top: -1000px;
  left: -1000px;
  padding: 0 0 1px;
  z-index: 2;
  // width: 110px;
  background-color: #ed2026;
  border: 1px solid #ed2026;
  opacity: 0;
  font-size: 11px;
  #chatClickedUser {
    padding: 0 20px 0 10px;
    height: 26px;
    line-height: 25px;
    font-weight: bold;
    color: #fff;
    background: #ed2026;
  }
  .chatContextMenuItem {
    display: block;
    margin-bottom: -1px;
    padding-left: 5px;
    height: 21px;
    border: 1px solid #f8f8f8;
    font-size: 12px;
    font-family:'맑은 고딕', '굴림';
    overflow: hidden;
    color: #000;
    cursor: pointer;
    background-color: #f8f8f8;
    &:last-child {
      border-bottom: 0;
    }
    &.noContents {
      height: 5px;
      line-height: 5px;
      padding: 0;
      cursor: auto;
      color: #999999;
      .chatContextMenuText {
        height: 5px;
        line-height: 5px;
        margin: 0;
      }
    }
    .chatContextMenuIcon {
      float: left;
      margin: 3px 5px 0 0;
      width: 16px;
      height: 16px;
      background-image: url(/img/default/sideview_nw2.png);
      &.userInfo {
        background-position: 0 0;
      }
      &.sendMessage {
        background-position: -30px 0;
      }
      &.askChat {
        background-position: -90px 0;
      }
      &.addFriend {
        background-position: -60px 0;
      }
      &.addBlacklist {
        background-position: -120px 0;
      }
      &.givePenalty {
        background-position: -180px 0;
      }
      &.sendTradePoint {
        background-image: url(/nlivechat/img/medal_icon-01.png);
        background-repeat: no-repeat;
        background-size: contain;
      }
      &.doMute {
        background-position: -150px 0;
      }
      &.doUnmute {
        background-position: -300px 0;
      }
    }
    .chatContextMenuText {
      float: left;
      margin-top: 4px;
      height: 14px;
      line-height: 14px;
      &.dangerousButton {
        color: #ff0000;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// chat-contextMenu.vue?f0942710